export default "__VITE_ASSET__e19a4893__"